import angular from 'angular'

import DropdownComponent from './vd-dropdown.component'
import DropdownSuggestionsComponent from './vd-dropdown-suggestions.component'

angular
  .module('vend.ui')
  .component('vdDropdown', DropdownComponent)
  .component('vdDropdownSuggestions', DropdownSuggestionsComponent)
